/** Keep explanatory copy as precise as the server's seconds-based policy. */
export function reviewWaitLabel(totalSeconds: number) {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return [
    minutes ? `${minutes} ${minutes === 1 ? 'minute' : 'minutes'}` : '',
    seconds || !minutes
      ? `${seconds} ${seconds === 1 ? 'second' : 'seconds'}`
      : '',
  ]
    .filter(Boolean)
    .join(' ');
}
